import Lottie from 'lottie-react'

import animation from '../../../../data/new-plate-25.json'
import styles from './animation.module.scss'

export const Animation = () => {
  return (
    <div className={styles.container}>
      <Lottie
        animationData={animation}
        renderer="svg"
        loop={true}
        autoplay={true}
      />
    </div>
  )
}
